<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Import Access Rules
        </p>
      </header>
      <section class="modal-card-body">
        <p class="mb-4">
          If you have multiple access rules that you want to process at the same time, you can import them by clicking the field below and selecting a spreadsheet file to upload.
        </p>
        <p class="mb-4">
          The spreadsheet file should have only two columns - the first column for <strong>Access Rule</strong> and the second column for <strong>Type</strong>. The available Types are <strong>Domain</strong> and <strong>Email</strong>.
        </p>
        <p class="mb-4">
          <a href="/files/example-access-rule-import.xlsx" class="underline">Click this link to download</a> an example spreadsheet for your own import.
        </p>
        <d-field label="File Import">
          <input ref="fileUpload" type="file">
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          Import File
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import { showErrorToast } from '@services/errorHandling.service';
  import axios from 'axios';

  export default {
    props: {
      subjectArea: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        saving: false,
        file: null,
      };
    },

    methods: {
      async saveForm() {
        this.saving = true;
        const file = this.$refs.fileUpload.files[0];
        const form = new FormData();
        form.append('File', file);
        try {
          await axios.post(`/api/subject-areas/${this.subjectArea.id}/access-rules/import`, form, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          await this.$parent.events.getAccessRules();
          this.$parent.close();
        } catch (error) {
          debugger;
          showErrorToast(error);
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>